module.exports = __webpack_public_path__ + "img/no_prev_inside.svg";